import styled from "@emotion/styled";
import { getBaseAppearanceModeVariablesPaper, getSize, SizeName } from "@mrocket/styles";
import { PaperProps } from "./Paper";
import { css } from "@emotion/react";


const getSpaceSize = getSize({
  tiny: 'var(--sizeBase2)',
  small: 'var(--sizeBase4)',
  medium: 'var(--sizeBase6)',
  large: 'var(--sizeBase8)',
  none: '0px'
})

export const PaperRoot = styled('div')<PaperProps>`
  ${props => getBaseAppearanceModeVariablesPaper(props.appearance, props.mode, props.radius, props.shadow)};
  display: block;
  
  padding: ${props => getSpaceSize(props.space)};

  ${props => props.hovered && css`
    &:hover {
      ${props.appearance === 'overlay'
        ? css`background-color: var(--colorFill4Alpha)`
        : css`opacity: 0.85`};
    }
  `};
`